<template>
  <div class="modal-dialog modal-xl intro-modal" @click="closeModal">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
        ></button>
      </div>
      <div class="modal-body">
        <vimeo-player
          ref="player"
          autoplay
          video-url="https://player.vimeo.com/video/1058319738?h=5e7d7ba74a"
          :video-id="null"
          class="video"
          :options="{ responsive: true }"
          :play="videoIsPlaying"
          @playing="onPlaying"
          @pause="onStop"
          @ended="onStop"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "ModalVideo",
  props: ["modalOpened"],
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
  setup() {
    const store = useStore();
    const player = ref(null);

    function onPlaying() {
      store.dispatch(`modal/setVideoIsPalying`, true);
    }

    function onStop() {
      store.dispatch("modal/setVideoIsPalying", false);
    }

    const videoIsPlaying = computed(() => store.state.modal.videoIsPlaying);
    const videoId = computed(() => store.state.modal.videoId);

    watch(videoIsPlaying, (isPlaying) => {
      if (!isPlaying) player.value.pause();
    });

    return {
      onStop,
      onPlaying,
      videoIsPlaying,
      videoId,
      player,
      store,
    };
  },
};
</script>
<style lang="scss" scoped>
.intro-modal {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  height: 100% !important;
  width: 100% !important;
  max-width: none !important;
  margin: 0px !important;
  z-index: 11 !important;

  .btn-close {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%)
      hue-rotate(214deg) brightness(102%) contrast(101%) !important;
  }

  .modal-content {
    height: 100% !important;
    background-color: rgba($color: #1e1e1e, $alpha: 0.9);
    border-radius: 0 !important;

    .modal-body {
      .video {
        margin: 50% 0 !important;
        transform: translateY(-50%) !important;
      }
    }
  }
}
</style>
